import * as yup from 'yup';

export const customEmailValidation = (errorMessage: string) =>
    yup.string().matches(/^(LOCAL\\)?[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, {
        message: errorMessage,
    });
